import { render, staticRenderFns } from "./Editdata.vue?vue&type=template&id=e22773e0&scoped=true&"
import script from "./Editdata.vue?vue&type=script&lang=js&"
export * from "./Editdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22773e0",
  null
  
)

export default component.exports